import script from "./ResellerContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResellerContent.vue?vue&type=script&setup=true&lang=js"

import "./ResellerContent.vue?vue&type=style&index=0&id=5fd02ef5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd02ef5"]])

export default __exports__